import {EValidationTestType} from "../../../utils/validationConfigs";

export const formConfig = {
    register: {
        birthday: {
            model: "register",
            name: "birthday",
            standardMessage: undefined,
            validationTests: [
                EValidationTestType.hasValue,
                EValidationTestType.isDate
            ],
            visible: true,
            showSuccess: true,
        },
    },
};
